'use strict';

import _typeof from "@babel/runtime/helpers/typeof";
import React from 'react';
import ReactDOM from 'react-dom';
import router from 'Router';
import Application from 'Components/Application';
import Backbone from 'backbone';
import { showSnackBar } from "Actions/D5SnackbarsActions";
import { Messages } from "Messages";
import "UserActionHandler/UserScriptHandler";
import { deleteAllCookies, formatMessage } from "D5Utils/functions";
import { UserSettings } from "D5Utils/UserSettings";
import { System } from "Constants/objects";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.array.iterator";
import { loadForm as _loadForm } from "Actions/ApplicationActions";
window.D5 = {
  isDebugMode: function isDebugMode() {
    return localStorage.getItem('DEBUG_MODE') != null;
  },
  loadForm: function loadForm(formObj) {
    _loadForm(formObj);
  }
};
Messages.init(UserSettings.getApplicationLang()).then(function () {
  Backbone.ajax = function (params) {
    var success = params.success;
    var error = params.error;

    if (_typeof(params.data) !== "object") {
      params.contentType = 'application/json';
    }

    params.success = function (data, textStatus, jqXHR) {
      if (data.ResponseCode === "000") {
        success.apply(this, arguments);
      }

      if (data.ResponseCode === "401") {
        localStorage.setItem(System.ReturnUrl, window.location.hash.slice(1));
        deleteAllCookies();
        localStorage.removeItem(System.current_user);
        router.navigateTo('login');
      }

      if (data.ResponseCode === "999") {
        console.table({
          Operation: this.url,
          Body: JSON.parse(this.data),
          ResponseText: data.ResponseText,
          ResponseId: data.ResponseId
        });
        showSnackBar({
          type: System.SNACKBAR_TYPES.Error,
          message: formatMessage(Messages.Errors.ErrorWhileRequest, [data.ResponseText])
        });
        error.apply(this, [jqXHR, 'error', data.ResponseText]);
      }
      /**
       * Parse error when upload files. Type of response is text so code above does not work.
       */


      if (_typeof(params.data) === "object") {
        try {
          var resp = JSON.parse(data);

          if (resp.ResponseCode === "999") {
            error.apply(this, arguments);
          } else {
            success.apply(this, arguments);
          }
        } catch (ignore) {
          success.apply(this, arguments);
        }
      }
    };

    params.error = function (jqXHR, textStatus, errorThrown) {
      error.apply(this, [jqXHR, textStatus, errorThrown]);
      showSnackBar({
        type: System.SNACKBAR_TYPES.Error,
        message: formatMessage(Messages.Errors.ErrorWhileRequest, [''])
      });
    };

    return Backbone.$.ajax.apply(Backbone.$, arguments);
  };
});
ReactDOM.render(React.createElement(Application, null), document.getElementById('app'));